var Fruitsdata = [
  {
    id: 1,
    cat: "fruits and vegetables",
    title: "STRAWBERRY PUNNET 200G",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/008c2a97-74f4-4d95-bf4a-ec76afba26b8_425x425.jpg",
    rs: "75",
    qt: "1pc",
    type: "frouit",
    daily: "organic",
    stock: "instock",
  },

  {
    id: 2,
    cat: "fruits and vegetables",
    title: "Apple Red Delicious - Washington",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/70726a6d-f35e-480c-ba42-c95e808e3ec1_425x425.jpg",
    rs: "199.5",
    qt: "500g | 1kg",
    type: "Freezed",
    stock: "instock",
  },
  {
    id: 3,
    cat: "fruits and vegetables",
    title: "Grapes Red Globe - Imported",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/f341c972-bc85-4b0d-8309-6bdaa4fd0cad_425x425.JPG",
    rs: "149.8",
    qt: " 200g | 500g | 1kg",
    type: "frouit",
    daily: "veg",
    stock: "instock",
  },
  {
    id: 4,
    cat: "fruits and vegetables",
    title: "Apple Fuji",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/620b0bb1-440e-4d83-896a-35bc6f274c3c_425x425.jpg",
    rs: "199.5",
    qt: "500g | 1kg",
    type: "frouit",
  },
  {
    id: 5,
    cat: "fruits and vegetables",
    title: "Avocado - imported",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/a473f647-d419-42d6-bceb-6859d017acbe_425x425.jpg",
    rs: "375.75",
    qt: "250 g | 500g | 1kg",
    type: "Exoticvegitable",
  },
  {
    id: 6,
    cat: "fruits and vegetables",
    title: "Blueberry - Exotic",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/83e591f2-ace2-4b45-8916-9a532bfea930_425x425.jpg",
    rs: "449.88",
    qt: "125g | 250 g",
    type: "Exoticfrouit",
    daily: "veg",
    stock: "instock",
  },
  {
    id: 7,
    cat: "fruits and vegetables",
    title: "FABBOX MIX NUT CHAAT 140G",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/8c875dc7-3a4b-43c9-8660-e235d52aa2f1_425x425.jpg",
    rs: "370",
    qt: "1pc",
    type: "frozen",
    stock: "instock",
  },
  {
    id: 8,
    cat: "fruits and vegetables",
    title: "NATURES PREMIUM MIXED DRY FRUITS 25",
    img: "https://d1z88p83zuviay.cloudfront.net/Images/no-images425x425.jpg",
    rs: "599",
    qt: "1pc",
    type: "frozen",
  },
  {
    id: 9,
    cat: "fruits and vegetables",
    title: "YUMMIEZ GREEN PEAS 500kg",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/b8473f37-a863-4a02-8bc5-81c523f5290e_425x425.jpg",
    rs: "105",
    qt: "1pc",
    type: "frozen",
  },
  {
    id: 10,
    cat: "fruits and vegetables",
    title: "YUMMIES GREEN PEAS 1kg",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/b8473f37-a863-4a02-8bc5-81c523f5290e_425x425.jpg",
    rs: "182",
    qt: "1pc",
    type: "frozen",
  },
  {
    id: 11,
    cat: "fruits and vegetables",
    title: "YUMMIEZ AMERICAN SWEET CORN 400G",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/67a26643-5b07-45cf-9678-58d912178d74_425x425.jpg",
    rs: "70",
    qt: "1PC",
    type: "frozen",
    stock: "instock",
  },

  {
    id: 12,
    cat: "fruits and vegetables",
    title: "Nectarine - Imported",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/8ddeaf63-7d49-4498-bfd8-2dc80e3df458_425x425.JPG",
    rs: "399.75",
    qt: "250 g | 500g | 1kg",
    type: "Exoticfrouit",
    stock: "instock",
  },
  {
    id: 13,
    cat: "fruits and vegetables",
    title: "Potato - Organic",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/b69c4a59-e516-4139-bbf3-6fab3282c28d_425x425.jpg",
    rs: "49",
    qt: "1kg",
    type: "vegitable",
    brand: "organic",
    daily: "veg",
    stock: "instock",
  },
  {
    id: 14,
    cat: "fruits and vegetables",
    title: "Green Peas",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/e052813e-041b-44ee-b255-b7356c6af4ac_425x425.JPG",
    rs: "189",
    qt: "1kg",
    type: "vegitable",
    daily: "organic",
  },
  {
    id: 15,
    cat: "fruits and vegetables",
    title: "Carrot Indian",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/5ffde13c-5920-43bc-9712-9d9a7a059875_425x425.JPG",
    rs: "18.75",
    qt: "250 g | 500g | 1kg",
    type: "vegitable",
    daily: "veg",
    stock: "instock",
  },
  {
    id: 16,
    cat: "fruits and vegetables",
    title: "Tomato - Organic",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/2a8cb901-3d5e-4c7b-a23d-55f36ff3c09b_425x425.jpg",
    rs: "29.5",
    qt: "500g | 1kg | 2kg",
    type: "vegitable",
    brand: "organic",
    daily: "organic",
  },
  {
    id: 17,
    cat: "fruits and vegetables",
    title: "Dragon Fruit",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/d85cf7ec-4eb3-4f45-a7da-b94bb315b9d2_425x425.jpg",
    rs: "124.5",
    qt: "500g | 1kg",
    type: "frouit",
  },
  {
    id: 18,
    cat: "fruits and vegetables",
    title: "Orange",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/52f5fdaa-c9c5-4026-bf57-5e2bf06c24cf_425x425.JPG",
    rs: "289",
    qt: "1kg",
    type: "frouit",
  },
  {
    id: 19,
    cat: "fruits and vegetables",
    title: "Custard Apple",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/63b69966-4855-4b1f-80a2-74796c8a5e09_425x425.JPG",
    rs: "87.25",
    qt: "250 g | 500g | 1kg",
    type: "frouit",
    daily: "veg",
    stock: "instock",
  },
  {
    id: 20,
    cat: "fruits and vegetables",
    title: "Thai Guavas - Imported",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/ccb9655e-80f3-4818-80d6-0e484addc173_425x425.jpg",
    rs: "224.75",
    qt: "250 g | 500g | 1kg",
    type: "Exoticfrouit",
  },
  {
    id: 21,
    cat: "fruits and vegetables",
    title: "Apple Royal Gala - New Zealand",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/7fb83bef-4c1c-4f81-96e6-44c4d3eac077_425x425.jpg",
    rs: "169.5",
    qt: "500g | 1kg",
    type: "Exoticfrouit",
    stock: "instock",
  },
  {
    id: 22,
    cat: "fruits and vegetables",
    title: "Apple Green",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/fb35012c-ed68-4553-af94-b44c35ed8586_425x425.jpg",
    rs: "199.5",
    qt: "500g | 1kg",
    type: "frouit",
    daily: "veg",
  },
  {
    id: 23,
    cat: "fruits and vegetables",
    title: "PEARS BEAUTY IMPORTED",
    img: "https://d1z88p83zuviay.cloudfront.net/Images/no-images425x425.jpg",
    rs: "224.5",
    qt: "500g | 1kg",
    type: "frozen",
    stock: "instock",
  },
  {
    id: 24,
    cat: "fruits and vegetables",
    title: "HA WALNUT WHOLE 500G",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/d450a015-e560-4a40-9876-9db2f6813566_425x425.JPG",
    rs: "699",
    qt: "1pc",
    type: "frozen",
    daily: "veg",
    stock: "instock",
  },
  {
    id: 25,
    cat: "fruits and vegetables",
    title: "CAULIFLOWER 1 PC PK NB",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/999a14d9-d3ad-4d97-b637-813aeebfdf69_425x425.jpg",
    rs: "29",
    qt: "1pc",
    type: "vegitable",
    daily: "veg",
    stock: "instock",
  },
  {
    id: 26,
    cat: "fruits and vegetables",
    title: "Onion",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/14c3fa54-5d8e-4238-903f-a8ef58132879_425x425.JPG",
    rs: "17.5",
    qt: "500g | 1kg | 2kg",
    type: "vegitable",
    brand: "organic",
    daily: "organic",
    stock: "instock",
  },
  {
    id: 27,
    cat: "fruits and vegetables",
    title: "Garlic",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/53825dfc-b626-4246-9c7a-19ec44f49471_425x425.JPG",
    rs: "14.9",
    qt: "100g | 200g | 300g",
    type: "vegitable",
    daily: "veg",
    stock: "outofstock",
  },
  {
    id: 28,
    cat: "fruits and vegetables",
    title: "Chilli Green",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/ef293d5a-93c6-420a-9d0c-a84973fb90d6_425x425.JPG",
    rs: "19.9",
    qt: "100g | 150g | 200g",
    type: "vegitable",
  },
  {
    id: 29,
    cat: "fruits and vegetables",
    title: "Coriander - Organic",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/ec08a00a-68d8-4cc6-85fe-f9c4dd6c52a4_425x425.jpg",
    rs: "21.9",
    qt: "100g | 250g | 500g",
    type: "vegitable",
    brand: "organic",
    daily: "organic",
  },
  {
    id: 30,
    cat: "fruits and vegetables",
    title: "Organic Brinjal Purple Stripes",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/1449b613-d093-4760-8b92-28fdbbcb07b2_425x425.jpg",
    rs: "29.75",
    qt: "250g | 500g | 1kg",
    type: "vegitable",
    brand: "organic",
    daily: "organic",
  },
  {
    id: 31,
    cat: "fruits and vegetables",
    title: "Baby Spinach/Palak - Exotic",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/2841946c-6155-402e-8e30-ffb53dc689b4_425x425.jpg",
    rs: "179.8",
    qt: "200g | 500g | 1kg",
    type: "Exoticvegitable",
    daily: "veg",
  },
  {
    id: 32,
    cat: "fruits and vegetables",
    title: "Swiss Chard Green - Exotic",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/2841946c-6155-402e-8e30-ffb53dc689b4_425x425.jpg",
    rs: "124.75",
    qt: "250g | 500g",
    type: "Exoticvegitable",
    daily: "veg",
  },
  {
    id: 33,
    cat: "fruits and vegetables",
    title: "SPRING ONION 1PC",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/edd0745d-af25-4cb4-86b1-f67d44dea186_425x425.jpg",
    rs: "35",
    qt: "1pc",
    type: "baby",
    daily: "veg",
  },
  {
    id: 34,
    cat: "fruits and vegetables",
    title: "Garlic Peeled Highfield",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/e8fbbd72-4af3-4d52-9411-637a2b2e2762_425x425.JPG",
    rs: "39",
    qt: "1pc",
    type: "baby",
    daily: "veg",
  },
  {
    id: 35,
    cat: "fruits and vegetables",
    title: "Garlic Chives GT",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/65760942-7277-498a-9d28-b570ac201906_425x425.jpg",
    rs: "39",
    qt: "1pc",
    type: "baby",
    daily: "veg",
  },
  {
    id: 36,
    cat: "fruits and vegetables",
    title: "GREEN GIANT WHOLE KERNEL SWEET CORN",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/cfc08f0b-e155-4f97-8720-493c6e2957cc_425x425.jpg",
    rs: "290",
    qt: "1pc",
    type: "canned",
    daily: "veg",
  },
  {
    id: 37,
    cat: "fruits and vegetables",
    title: "AG CHICK PEAS 400G",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/9ae7528f-e389-41b0-a7a7-3b13061533b6_425x425.JPG",
    rs: "135",
    qt: "1pc",
    type: "canned",
    stock: "outofstock",
  },
  {
    id: 38,
    cat: "fruits and vegetables",
    title: "EPICURE PETITS POIS&WHL BBY CARROT",
    img: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/e164c1b1-5623-4483-a46f-965bcf056081_425x425.jpg",
    rs: "250",
    qt: "1pc",
    type: "canned",
    stock: "outofstock",
  },
];
    

export default Fruitsdata;


